import NoDataCard from '@/components/NotFound/NoDataCard';
import { CAMPAIGN_MANAGEMENT_REQUEST } from '@/constants/campaignManagement';
import { getCampaignsTableAppliedFilters } from '@/helpers/campaignManagement';
import { useRequestSaver } from '@/hooks/RequestSaver';
import {
  getCampaignsData,
  getClients,
  resetFilters,
  setFilters,
  updateFilteredCampaignsData,
} from '@/store/slices/campaignManagementSlice';
import { Paper } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Filters from './Filters';
import CampaignsTable from './Table';
import Errors from './components/Errors';

const CampaignManagement = () => {
  const dispatch = useDispatch();
  const requestSaver = useRequestSaver();
  const campaignManagement = useSelector(state => state.campaignManagement);
  const {
    campaignsData,
    totalCampaigns,
    campaignsDataError,
    filters,
    campaignsDataRequestId: loading,
    clients,
    clientsRequestId: loadingClients,
  } = campaignManagement;

  const _setFilters = useCallback(
    newFilters => {
      dispatch(setFilters(newFilters));
    },
    [dispatch],
  );

  const _resetFilters = useCallback(() => {
    dispatch(resetFilters());
  }, [dispatch]);

  const loadCampaignsData = useCallback(() => {
    dispatch(getCampaignsData(requestSaver.requestSaverSetCancellation(CAMPAIGN_MANAGEMENT_REQUEST.CAMPAIGNS_DATA)));
  }, [requestSaver, dispatch]);

  const updateCampaignsData = useCallback(() => {
    dispatch(updateFilteredCampaignsData());
  }, [dispatch]);

  useEffect(() => {
    if (!clients) {
      dispatch(getClients());
    }
  }, [dispatch, clients]);

  useEffect(() => {
    if (!loadingClients) {
      requestSaver.requestSaverAbortAll();
      loadCampaignsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loadingClients,
    filters.status,
    filters.pacingStatus,
    filters.channelTypes,
    filters.dateRangeStart,
    filters.dateRangeEnd,
    filters.clients,
    filters.advertisers,
    filters.campaigns,
    filters.search,
    filters.page,
    filters.limit,
    filters.sort,
    filters.isArchived,
    filters.platform,
  ]);

  useEffect(
    () => () => {
      requestSaver.requestSaverAbortAll();
    },
    [],
  );

  useEffect(() => {
    if (!loading) {
      updateCampaignsData();
    }
  }, [updateCampaignsData, filters.level, loading]);

  return campaignsDataError ? (
    <NoDataCard renderContent={Errors[campaignsDataError]} sx={{ height: '100%' }} />
  ) : (
    <div>
      <Filters
        filters={getCampaignsTableAppliedFilters(filters)}
        setFilters={_setFilters}
        resetFilters={_resetFilters}
        clients={clients}
      />

      <Paper className='mx-7 mb-7 grid grid-cols-1'>
        <CampaignsTable campaignsData={campaignsData} rowCount={totalCampaigns} loading={!!loading} />
      </Paper>
    </div>
  );
};

export default CampaignManagement;
